import React, { useState, useEffect } from 'react';
import { getCrops } from '../services/api';
import './CropSelector.css';

const CROP_CONFIG = {
  barley: {
    icon: '🌾',
    title: 'Barley',
    subtitle: 'Hordeum vulgare',
    color: '#c8a951',
    gradient: 'linear-gradient(135deg, #d4a843 0%, #a88734 100%)',
  },
  wheat: {
    icon: '🌿',
    title: 'Wheat',
    subtitle: 'Triticum aestivum',
    color: '#d4a843',
    gradient: 'linear-gradient(135deg, #c8a951 0%, #b8963f 100%)',
  },
  potato: {
    icon: '🥔',
    title: 'Potato',
    subtitle: 'Solanum tuberosum',
    color: '#8B7355',
    gradient: 'linear-gradient(135deg, #a0845c 0%, #7a6548 100%)',
  },
  oats: {
    icon: '🌱',
    title: 'Oats',
    subtitle: 'Avena sativa',
    color: '#7fb069',
    gradient: 'linear-gradient(135deg, #7fb069 0%, #5a9a42 100%)',
  },
  strawberry: {
    icon: '🍓',
    title: 'Strawberry',
    subtitle: 'Fragaria × ananassa',
    color: '#e74c5e',
    gradient: 'linear-gradient(135deg, #e74c5e 0%, #c43a4b 100%)',
  },
  forages: {
    icon: '🌿',
    title: 'Forages',
    subtitle: 'Grassland & Forage crops',
    color: '#2d8659',
    gradient: 'linear-gradient(135deg, #2d8659 0%, #1e6b45 100%)',
  },
  other: {
    icon: '🧬',
    title: 'Other Crops',
    subtitle: 'Additional species',
    color: '#6c757d',
    gradient: 'linear-gradient(135deg, #6c757d 0%, #495057 100%)',
  },
};

function CropSelector({ onSelectCrop }) {
  const [cropData, setCropData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadCropData();
  }, []);

  const loadCropData = async () => {
    try {
      const result = await getCrops();
      setCropData(result.crop_tables || {});
    } catch (err) {
      console.error('Failed to load crop data:', err);
    } finally {
      setLoading(false);
    }
  };

  const displayCrops = ['barley', 'wheat', 'potato', 'oats', 'strawberry', 'forages'];

  if (loading) {
    return (
      <div className="crop-selector-container">
        <div className="crop-loading">
          <div className="crop-loading-spinner" />
          <p>Loading crop database...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="crop-selector-container">
      <div className="crop-selector-header">
        <div className="crop-header-icon">🧬</div>
        <h1>Genomic Database Platform</h1>
        <p className="crop-header-subtitle">
          Select your crop to access breeding data, genomic analysis, and AI-powered insights
        </p>
      </div>

      <div className="crop-grid">
        {displayCrops.map((cropKey) => {
          const config = CROP_CONFIG[cropKey];
          const tables = cropData[cropKey] || [];
          const tableCount = tables.length;

          return (
            <div
              key={cropKey}
              className="crop-card"
              onClick={() => onSelectCrop(cropKey)}
              style={{ '--crop-color': config.color, '--crop-gradient': config.gradient }}
            >
              <div className="crop-card-accent" />
              <div className="crop-card-body">
                <div className="crop-card-icon">{config.icon}</div>
                <h3 className="crop-card-title">{config.title}</h3>
                <p className="crop-card-subtitle">{config.subtitle}</p>
                <div className="crop-card-stats">
                  <span className="crop-stat-badge">
                    {tableCount} {tableCount === 1 ? 'dataset' : 'datasets'}
                  </span>
                </div>
              </div>
              <div className="crop-card-arrow">→</div>
            </div>
          );
        })}
      </div>

      <div className="crop-selector-footer">
        <p>© Kovi MR — Graminor</p>
      </div>
    </div>
  );
}

export default CropSelector;
